/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    BadgesIconListFragment,
    ContentBlockFragment,
    KolLeaderboardDataFragment,
    KolLeaderboardFragment,
} from '@graphqlTypes/sitecore';
import { useTranslation } from 'next-i18next';
import { format } from 'date-fns';
import { useCallback, useEffect, useState } from 'react';
import { withBasePath, withFullPath } from '@src/common/path-convert';
import LeaderBoardItem from '@components/kol/LeaderBoardItem';
import BadgeDescription from '@components/badge-description/BadgeDescription';
import cn from 'classnames';
import useWindowSize from '@src/utils/useWindowSize';

type Props = {
    content: KolLeaderboardFragment;
    contentBlock: ContentBlockFragment;
    badgesIconData: BadgesIconListFragment[] | [];
};

// type PageKolLeaderboardData = {
//     kolProfileLink?: Maybe<LookupField>;
//     race1stSrc?: Maybe<TextField>;
//     race1stText?: Maybe<TextField>;
//     race2ndSrc?: Maybe<TextField>;
//     race2ndText?: Maybe<TextField>;
// };

const KolTemplate = ({ content, contentBlock, badgesIconData }: Props) => {
    const { t } = useTranslation(['kol', 'common']);
    const { width } = useWindowSize();
    console.log('width-----', width);
    // const width790 = width > 790;
    const SPad = width >= 630 && width <= 790;
    const width790 = width > 790;
    // const width1024 = width >= 1024;

    const PadSize = SPad || width790;

    const [kolList, setKolList] = useState<KolLeaderboardDataFragment[]>([]);

    const betpickUrl = useCallback(() => {
        const link = content?.nextRaceLink?.targetItem?.path.match(/\/(betpick\/.*)/);
        return link ? link[1] : '';
    }, [content?.nextRaceLink?.targetItem?.path]);

    const lastUpdate = content.lastUpdate?.dateValue
        ? format(content.lastUpdate?.dateValue, 'dd/MM/yyyy')
        : '';
    const comingSoonMode = content.comingSoonMode?.boolValue || false;

    // const pxToPCT = (v: number) => {
    //     const num = (v / width) * 100;
    //     return num + '%';
    // };

    useEffect(() => {
        const filterList = content.children
            .filter(
                (v: KolLeaderboardDataFragment) =>
                    v?.kolProfileLink?.targetItem !== null &&
                    v?.kolProfileLink?.targetItem?.profileEnabled?.boolValue
            )
            .sort(
                (a: KolLeaderboardDataFragment, b: KolLeaderboardDataFragment) =>
                    Number(a?.kolProfileLink?.targetItem?.rank?.value) -
                    Number(b?.kolProfileLink?.targetItem?.rank?.value)
            );
        setKolList(filterList);
    }, [content.children]);

    // const filterBadges = (list: any) => {
    //     const filteredBadges: any[] =
    //         (list?.badges &&
    //             list?.badges.length > 0 &&
    //             list?.badges?.flatMap((badge: any) =>
    //                 badge.children.filter(
    //                     (child: any) => child.badgeIconLink && child.badgeIconLink.targetItem
    //                 )
    //             )) ||
    //         [];
    //     return filteredBadges;
    // };

    // console.log('kolList---', kolList);

    return (
        <div
            className={cn(
                'flex justify-center items-center flex-col',
                PadSize ? 'my-6 px-[24px]' : 'my-4 px-[12px]'
            )}
        >
            <div
                className={cn(
                    'bg-custom-gradient rounded-xl px-3 py-3 overflow-hidden',
                    'w-full lg:w-[786px]'
                    //width790 ? 'w-[786px]' : SPad ? 'w-[600px]' : 'w-[350px]'
                )}
            >
                <div className='flex justify-between items-center border-b border-[#D0E6FC] pb-2'>
                    <div className='text-lg font-medium'>{t('kol:KOLleaderboard')}</div>
                    {content?.nextRaceDisplayText?.value?.trim().length !== 0 && (
                        <div
                            className={cn('inAppLink text-sm font-medium inline-flex items-center')}
                            data-href={betpickUrl()}
                        >
                            {content.nextRaceIcon?.src && (
                                <img
                                    className='w-6 h-6 mr-1'
                                    src={withFullPath(content.nextRaceIcon?.src || '')}
                                    alt=''
                                    loading='lazy'
                                />
                            )}
                            {content?.nextRaceDisplayText?.value ?? ''}
                            <img
                                className='w-5 h-5'
                                src={withBasePath('/images/kol/i-b-arrowRight.svg')}
                                alt=''
                                loading='lazy'
                            />
                        </div>
                    )}
                </div>

                <div>
                    <div className={cn('flex text-left font-medium text-[11px] text-black pt-3')}>
                        <div
                            className={cn('text-center')}
                            style={{ flexBasis: SPad || width790 ? '45px' : '34px' }}
                        >
                            {t('profile.rank')}
                        </div>
                        <div
                            className={cn(
                                PadSize ? 'basis-[190px]' : 'basis-[120px]',
                                'text-center'
                            )}
                            //style={{ flexBasis: '30%' }}
                        >
                            {t('profile.kol')}
                        </div>
                        <div
                            className={cn('text-center', 'flex-1')}
                            // style={{ flexBasis: SPad ? '80px' : width790 ? '130px' : '75px' }}
                        >
                            {t('profile.strikeRate')}
                        </div>
                        <div
                            className={cn('text-center', 'flex-1')}
                            // style={{ flexBasis: SPad ? '85px' : width790 ? '124px' : '73px' }}
                        >
                            {t('profile.score')}
                        </div>
                        {PadSize && (
                            <div className='text-center flex-[2]'>{t('profile.betPickVideo')}</div>
                        )}
                        <div className={cn('text-center', 'w-[24px]')}></div>
                    </div>
                    {/* <div
                        className={cn(
                            'grid  text-left font-bold text-[11px] text-black border-b border-[#D0E6FC] pb-1',
                            PadSize ? 'grid-cols-5 gap-5' : 'grid-cols-4 gap-4'
                        )}
                    >
                        <div className={cn('text-left', width790 ? 'pl-2' : 'pl-1')}>
                            {t('profile.rank')}
                        </div>
                        <div className={cn(PadSize ? '-translate-x-[20px]' : '')}>KOL</div>
                        <div
                            className={cn(
                                PadSize ? '-translate-x-[38px]' : '-translate-x-[8px]',
                                width === 640 ? '!-translate-x-[3px]' : '',
                                width === 744 ? '!-translate-x-[31px]' : '',
                                width === 753 ? '!-translate-x-[36px]' : ''
                            )}
                        >
                            {t('profile.strikeRate')}
                        </div>
                        <div
                            className={cn(
                                PadSize ? '-translate-x-[55px]' : '-translate-x-[5px]',
                                width === 640 ? '!-translate-x-[24px]' : '',
                                width === 744 ? '!-translate-x-[45px]' : '',
                                width === 753 ? '!-translate-x-[50px]' : ''
                            )}
                        >
                            {t('profile.score')}
                        </div>
                        {PadSize && (
                            <div className='-translate-x-[55px]'>{t('profile.betPickVideo')}</div>
                        )}
                    </div> */}
                    {kolList.map((i, index) => (
                        <LeaderBoardItem
                            key={index}
                            kolData={i}
                            contentBlock={contentBlock}
                            comingSoonMode={comingSoonMode}
                        ></LeaderBoardItem>
                    ))}
                </div>
                {/* date & how */}
                <div className='flex justify-between items-center mt-3 mb-2'>
                    {content?.lastUpdate?.dateValue && content?.lastUpdate?.dateValue > 0 && (
                        <div className='text-[11px] text-black font-normal'>{`${t(
                            'kol:profile.lastTimeUpdate'
                        )} ${lastUpdate}`}</div>
                    )}
                    <div
                        className='inAppLink  text-right text-[11px] text-[#003C84] font-bold'
                        data-href='misc/kol-game-rules'
                    >
                        {t('kol:profile.gameRules')}
                        <img
                            className='w-4 h-4 ml-1'
                            src={withBasePath('/images/kol/i-FAQ.svg')}
                            alt=''
                            loading='lazy'
                        />
                    </div>
                </div>
                {/* 徽章 */}
                <BadgeDescription
                    badgeIconData={badgesIconData}
                    className={'pb-2'}
                ></BadgeDescription>
                {/* 底部Remark */}
                <div className='text-[9px] text-black font-medium'>{t('common:Remark')}</div>
            </div>
        </div>
        // <>
        //     {
        //         <div className={styles['leader-bord-content']}>
        //             {content?.nextRaceDisplayText?.value?.trim().length !== 0 && (
        //                 <div
        //                     className={classNames(styles['selection-title'], 'inAppLink')}
        //                     data-href={betpickUrl()}
        //                 >
        //                     <span className={styles.trumpet}></span>
        //                     {content?.nextRaceDisplayText?.value ?? ''}
        //                     <span className={styles.arrow}></span>
        //                 </div>
        //             )}

        //             <div className={styles['header-content']}>
        //                 <div className={styles['basis-2/12']}>{t('profile.rank')}</div>
        //                 <div className={styles['basis-4/12']}>KOL</div>
        //                 <div className={styles['basis-1/12']}>{t('profile.strikeRate')}</div>
        //                 <div className={styles['basis-3/12']}>
        //                     {t('profile.betPickVideo')}
        //                     {/* <span className={styles.star}></span> */}
        //                 </div>
        //                 <div className={styles['basis-2/12']}>{t('profile.score')}</div>
        //             </div>

        //             {kolList.map((i: KolLeaderboardDataFragment) => {
        //                 const item: DetailKolProfileBaseFragment | undefined =
        //                     i?.kolProfileLink?.targetItem;
        //                 return (
        //                     <div className={styles['item-content']} key={item?.name}>
        //                         <div
        //                             className={classNames(
        //                                 styles['basis-2/12'],
        //                                 'flex flex-col justify-center items-center',
        //                                 styles.item,
        //                                 styles['item-1']
        //                             )}
        //                         >
        //                             {item?.trendIIcon?.value && (
        //                                 <img
        //                                     className='w-[10px]'
        //                                     src={withBasePath(
        //                                         `${
        //                                             item?.trendIIcon?.value === 'Up'
        //                                                 ? '/images/kol/up.svg'
        //                                                 : '/images/kol/down.svg'
        //                                         }`
        //                                     )}
        //                                     loading='lazy'
        //                                     alt=''
        //                                 />
        //                             )}
        //                             <div>{item?.rank?.value}</div>
        //                         </div>
        //                         <div
        //                             className={classNames(
        //                                 styles['basis-4/12'],
        //                                 ' inAppLink',
        //                                 styles.item,
        //                                 styles['item-2']
        //                             )}
        //                             onClick={() => {
        //                                 router.push(
        //                                     removeCIDUrl(
        //                                         `/kol-profile/${item?.name}${location.search}`
        //                                     )
        //                                 );
        //                             }}
        //                         >
        //                             <div className={styles['img-box']}>
        //                                 <img
        //                                     src={item?.kolThumbSq?.src || ''}
        //                                     alt={item?.name || ''}
        //                                     width='35'
        //                                     height='35'
        //                                     loading='lazy'
        //                                 />
        //                             </div>
        //                             <div className={styles.name}>
        //                                 <div>
        //                                     {i?.kolProfileLink?.targetItem?.kolName?.value || ''}
        //                                 </div>
        //                                 <div className={styles['badges-box']}>
        //                                     {filterBadges(item).map((b, iconIndex: number) => {
        //                                         return (
        //                                             b?.badgeIconLink?.targetItem?.badgeIconImage
        //                                                 ?.src && (
        //                                                 <img
        //                                                     key={iconIndex}
        //                                                     src={
        //                                                         b?.badgeIconLink?.targetItem
        //                                                             ?.badgeIconImage?.src || ''
        //                                                     }
        //                                                     loading='lazy'
        //                                                     alt=''
        //                                                 />
        //                                             )
        //                                         );
        //                                     })}
        //                                 </div>
        //                             </div>
        //                         </div>
        //                         <div
        //                             className={classNames(
        //                                 styles['basis-1/12'],
        //                                 'item-3 font-bold',
        //                                 styles.item,
        //                                 styles['item-3']
        //                             )}
        //                         >
        //                             {item?.strikeRate?.value}
        //                         </div>
        //                         <div
        //                             className={classNames(
        //                                 styles['basis-3/12'],
        //                                 ' font-bold',
        //                                 styles.item,
        //                                 styles['item-4']
        //                             )}
        //                         >
        //                             {content?.comingSoonMode?.boolValue ? (
        //                                 `${t('profile.comingSoon')}`
        //                             ) : i.race1stSrc?.value || i.race2ndSrc?.value ? (
        //                                 <>
        //                                     {i.race1stSrc?.value && (
        //                                         <div
        //                                             className={classNames(
        //                                                 styles.race,
        //                                                 i.race1stType?.value === 'Video' &&
        //                                                     !i.race1stVideoNative?.boolValue &&
        //                                                     'video-pop'
        //                                             )}
        //                                             onClick={() => {
        //                                                 if (i.race1stType?.value === 'Video') {
        //                                                     return videoNative(
        //                                                         i.race1stVideoNative?.boolValue ??
        //                                                             false,
        //                                                         i.race1stVideoNativePip
        //                                                             ?.boolValue ?? false,
        //                                                         i.race1stSrc?.value ?? '',
        //                                                         i.race1stText?.value ?? ''
        //                                                     );
        //                                                 }
        //                                                 linkTo(
        //                                                     i.race1stType?.value ?? 'Video',
        //                                                     i.race1stSrc?.value ?? ''
        //                                                 );
        //                                             }}
        //                                             data-poster={i.race1stSrc?.value}
        //                                         >
        //                                             <span>{i.race1stText?.value}</span>
        //                                             <div className={styles['play-icon']}>
        //                                                 <div></div>
        //                                             </div>
        //                                         </div>
        //                                     )}
        //                                     {i.race2ndSrc?.value && (
        //                                         <div
        //                                             className={classNames(
        //                                                 styles.race,
        //                                                 i.race2ndType?.value === 'Video' &&
        //                                                     !i.race2ndVideoNative?.boolValue &&
        //                                                     'video-pop'
        //                                             )}
        //                                             onClick={() => {
        //                                                 if (i.race2ndType?.value === 'Video') {
        //                                                     return videoNative(
        //                                                         i.race2ndVideoNative?.boolValue ??
        //                                                             false,
        //                                                         i.race2ndVideoNativePip
        //                                                             ?.boolValue ?? false,
        //                                                         i.race2ndSrc?.value ?? '',
        //                                                         i.race2ndText?.value ?? ''
        //                                                     );
        //                                                 }
        //                                                 linkTo(
        //                                                     i.race2ndType?.value ?? 'Video',
        //                                                     i.race2ndSrc?.value ?? ''
        //                                                 );
        //                                             }}
        //                                             data-poster={i.race2ndSrc?.value}
        //                                         >
        //                                             <span>{i.race2ndText?.value}</span>
        //                                             <div className={styles['play-icon']}>
        //                                                 <div></div>
        //                                             </div>
        //                                         </div>
        //                                     )}
        //                                 </>
        //                             ) : (
        //                                 <div className='text-center'>-</div>
        //                             )}
        //                         </div>
        //                         <div
        //                             className={classNames(
        //                                 styles['basis-2/12'],
        //                                 ' font-bold',
        //                                 styles.item,
        //                                 styles['item-5']
        //                             )}
        //                         >
        //                             {item?.score?.value ?? '-'}
        //                         </div>
        //                     </div>
        //                 );
        //             })}

        //             <div className={styles['selection-footer']}>
        //                 {content?.lastUpdate?.dateValue && content?.lastUpdate?.dateValue > 0 && (
        //                     <div className={styles['last-update-time']}>{`${t(
        //                         'profile.lastTimeUpdate'
        //                     )} ${lastUpdate}`}</div>
        //                 )}
        //                 <div
        //                     className='inAppLink flex-1 text-right'
        //                     data-href='misc/kol-game-rules'
        //                 >
        //                     {t('profile.gameRules')}
        //                     <div className={styles['question-mark']}>?</div>
        //                 </div>
        //             </div>
        //         </div>
        //     }
        // </>
    );
};

export default KolTemplate;
